import { createAction } from '@reduxjs/toolkit';

export const setTargetService = createAction('setTargetService', (params) => ({
  payload: params,
}));

export const updateProfileState = createAction('updateProfileState', (params) => ({
  payload: params,
}));

/** Sign-in status written by the bulk action (GLX-2012), applied to the loaded rows in place. */
export const setTeamMembersLoginEnabled = createAction(
  'setTeamMembersLoginEnabled',
  (params: {
    memberships: Array<{ teamMembershipId: number; accountId: number }>;
    loginEnabled: boolean;
  }) => ({ payload: params }),
);
